"use client"

import { useLayoutEffect, type ReactNode } from "react"
import { useGlobalDialogStore } from "@/stores/use-global-dialog-store"

import { AppDialogSurface } from "./app-dialog"
import { useDialogEntryId } from "./dialog-entry-context"

/** Preserves an inventoried composer when used globally, pinned, or embedded. */
export function CustomDialogContent({
  title,
  titleProvided,
  children,
}: {
  title: ReactNode
  titleProvided?: boolean
  children: ReactNode
}) {
  const entryId = useDialogEntryId()
  const setVariant = useGlobalDialogStore((state) => state.setEntryVariant)
  useLayoutEffect(() => {
    if (entryId) setVariant(entryId, "custom", "all")
  }, [entryId, setVariant])
  if (!entryId) return <>{children}</>

  return (
    <AppDialogSurface variant="custom" title={title} titleProvided={titleProvided}>
      {children}
    </AppDialogSurface>
  )
}
